export default () => ({
  showModal: false,
  showModalDraft: false,
  showModalReply: false,
  modalData: {},
  replyPostData: {},
  quotePostData: {},
  showModalAboutUs: false,
});
